import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "video",
  "use": "video-usage",
  "viewBox": "0 0 20 14",
  "content": "<symbol viewBox=\"0 0 20 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"video\">\n<path d=\"M11.6736 0H1.65972C0.743056 0 0 0.745914 0 1.66611V11.7185C0 12.6387 0.743056 13.3846 1.65972 13.3846H11.6736C12.5903 13.3846 13.3333 12.6387 13.3333 11.7185V1.66611C13.3333 0.745914 12.5903 0 11.6736 0ZM18.25 1.31406L14.4444 3.94916V9.43546L18.25 12.0671C18.9861 12.576 20 12.0566 20 11.1678V2.21334C20 1.328 18.9896 0.805168 18.25 1.31406Z\" fill=\"black\" fill-opacity=\"0.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol